// extracted by mini-css-extract-plugin
module.exports = {"item":"c3X7v","active":"-aLtg","label":"_2JGPj","leftChevron":"_2XYX4","rightChevron":"QMOts","icon":"_2g8bW","back":"_2cHJ3"};